export default __webpack_public_path__ + "static/media/logo22.14c7003d.png";